import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "./Sidebar";
import AdministrationSidebar from "./AdministrationSidebar";
import SupportSidebar from "./SupportSidebar";
import adminSurface from "./AdminSurface.module.css";
import studio from "../../styles/studioPage.module.css";

interface LayoutWithSidebarProps {
    children: React.ReactNode;
    adminMode?: boolean;
    projectLinks?: { name: string; path: string; logo: string }[];
    fetchProjects?: () => Promise<void>;
    contentType?: "text" | "cartel" | "newsletter";
}

const LayoutWithSidebar: React.FC<LayoutWithSidebarProps> = ({
    children,
    adminMode = false,
    projectLinks = [],
    fetchProjects,
    contentType = "text",
}) => {
    const location = useLocation();

    const showMainSidebar =
        !adminMode &&
        (location.pathname.startsWith("/projects") ||
            location.pathname.startsWith("/cartel-projects") ||
            location.pathname.startsWith("/newsletter-projects") ||
            location.pathname.startsWith("/create/text") ||
            location.pathname.startsWith("/create/drafts") ||
            location.pathname.startsWith("/create/trash") ||
            location.pathname.startsWith("/create/promotional-text") ||
            location.pathname.startsWith("/create/text-remix") ||
            location.pathname.startsWith("/create/cartel") ||
            location.pathname.startsWith("/create/cartel-remix") ||
            location.pathname.startsWith("/create/cartel-translation") ||
            location.pathname.startsWith("/create/newsletter") ||
            location.pathname.startsWith("/create/newsletter-remix") ||
            location.pathname.startsWith("/create/newsletter-translation") ||
            location.pathname.startsWith("/create/text-to-speech") ||
            location.pathname.startsWith("/create/voices") ||
            location.pathname.startsWith("/create/sound-effects") ||
            location.pathname.startsWith("/create/translation") ||
            location.pathname.startsWith("/create/map-studio") ||
            location.pathname.startsWith("/create/audio-editing") ||
            location.pathname.startsWith("/create/sound-library"));

    const databasePage = location.pathname.startsWith("/database");
    const showSupportSidebar = !adminMode && location.pathname.startsWith("/support");
    const hasSideColumn = showMainSidebar || adminMode || showSupportSidebar;
    const studioSurface = adminMode || showSupportSidebar;
    const mainClass = [
        hasSideColumn || databasePage ? "app-content" : "app-content-full",
        showMainSidebar || databasePage ? "app-content--flush" : "",
        adminMode || showSupportSidebar ? "app-content--with-fixed-sidebar" : "",
        studioSurface ? `${adminSurface.root} ${studio.page}` : "",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className="app-layout">
            <Header />
            <div className="app-body">
                {showMainSidebar && (
                    <Sidebar projectLinks={projectLinks} fetchProjects={fetchProjects} contentType={contentType} />
                )}
                {adminMode && <AdministrationSidebar />}
                {showSupportSidebar && <SupportSidebar />}
                <main className={mainClass}>{children}</main>
            </div>
        </div>
    );
};

export default LayoutWithSidebar;
